import { Box, Grid } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IRootState } from '../../../../../redux/types'
import NotFilter from '../../../../shared/components/NotFilter'
import OfferBlock from './OfferBlock'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'

const CarouselContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    '& .carousel .slider': {
      width: '67%'
    }
  }
}))

const CardContainer = styled(Box)({
  lineHeight: 0,
  margin: 0,
  position: 'relative',
  '& h5, h6, p': {
    color: '#FAFAFA',
    textShadow: '0 1px 1px #222'
  }
})

interface OffersPanelProps {
  userCounterViewsOffer: any
  subsection: string
}

function OffersPanel({ userCounterViewsOffer, subsection }: OffersPanelProps) {
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()
  const { offers, loading } = useSelector((state: IRootState) => state.offer)
  const [counted, setCounted] = useState<number[]>([])

  const counterViews = (offerId: number) => {
    if (!counted.includes(offerId)) {
      dispatch(userCounterViewsOffer(offerId))
      let tmpCounted = [...counted]
      tmpCounted.push(offerId)
      setCounted(tmpCounted)
    }
  }

  return (
    <>
      <Grid item xs={12}>
        {offers.filter((offer: any) => offer.highlight === 1).length >= 2 && !loading && (
          <CarouselContainer>
            <Carousel centerMode={!isMobile} autoPlay showThumbs={false} showArrows={!isMobile} interval={5000} infiniteLoop>
              {offers
                .filter((offer: any) => offer.highlight === 1)
                .map((offer: any) => (
                  <CardContainer onMouseOver={() => counterViews(offer.id)} key={offer.id}>
                    <OfferBlock type={0} offer={offer} />
                  </CardContainer>
                ))}
            </Carousel>
          </CarouselContainer>
        )}
      </Grid>

      <Grid container spacing={isMobile ? 1 : 3} sx={{ marginTop: isMobile ? 2 : 3 }}>
        {offers.filter((offer: any) => offer.highlight === 0 || offer.highlight === null).length === 0 && !loading ? (
          <NotFilter subsection={subsection} />
        ) : (
          offers
            .filter((offer: any) => offer.highlight === 0 || offer.highlight === null)
            .map((offer: any) => (
              <Grid item xs={6} md={4} onMouseOver={() => counterViews(offer.id)} key={offer.id}>
                <OfferBlock type={1} offer={offer} />
              </Grid>
            ))
        )}
      </Grid>
    </>
  )
}

export default OffersPanel
